module.exports = __webpack_public_path__ + "img/w21b.206bb2cd.jpg";